import { stringify } from 'qs';

export interface IError {
    message: string;
    file?: string | null;
    line?: number | null;
    column?: number | null;
    stack?: string | null;
}

export function onError(event: Event | string, source?: string, fileno?: number, columnNumber?: number, error?: Error) {
    columnNumber = columnNumber ?? (window.event && (window.event as any).errorCharacter);
    const stack = error?.stack ?? null;

    const errorObject: IError = {
        message: event instanceof Event ? event.toString() : event,
        file: source,
        line: fileno,
        column: columnNumber,
        stack,
    };

    console.error(errorObject);
    redirect(errorObject);

    // the error can still be triggered as usual, we just wanted to know what's happening on the client side
    return false;
}

export function onUnhandledRejection(event: any) {
    const error: Error = event.reason || event.detail.reason;

    redirect({
        message: error.message,
        file: error.name,
        stack: error.stack,
    });

    return false;
}

export function errorRedirect(error: Error) {
    console.error(error);

    return redirect({
        message: error.message,
        file: error.name,
        stack: error.stack,
    });
}

function redirect(error: IError) {
    // eslint-disable-next-line
    debugger;
    const query = stringify(error);
    if (typeof window != 'undefined') window.location.href = `/error?${query}`;
}
